<script lang="ts">
import { sanitizeRichTextHtml } from '$lib/utils/sanitise.js';
import { toAnchorId } from '$lib/utils/servicePageNav.js';
import { prepareHtmlLinks } from '$lib/utils/url.js';

interface Props {
    navLabel?: string;
    anchorId?: string;
    heading?: string;
    headingLevel?: 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    richText?: string;
    hideBlock?: boolean;
}

let {
    navLabel = '',
    anchorId = '',
    heading = '',
    headingLevel = 'h3',
    richText = '',
    hideBlock = false,
}: Props = $props();

let sectionId = $derived(toAnchorId(anchorId || navLabel || heading));
</script>

{#if !hideBlock}
    <section class="service-page-section" id={sectionId}>
        {#if heading}
            <svelte:element this={headingLevel} class="service-page-section__heading">
                {heading}
            </svelte:element>
        {/if}
        {#if richText}
            <div class="service-page-section__content builder-text">
                {@html prepareHtmlLinks(sanitizeRichTextHtml(richText))}
            </div>
        {/if}
    </section>
{/if}

<style lang="scss">
    @use '/src/scss/mixins/builder-rich-text' as builder-mixins;

    .service-page-section {
        scroll-margin-top: 11rem;
    }

    .service-page-section__heading {
        color: var(--colour-dreamless-sleep);
        font-family: var(--font-secondary);
        font-size: 1.6rem;
        font-weight: 600;
        letter-spacing: 0.032rem;
        line-height: 1.2;
        margin-bottom: 1.6rem;
    }

    .service-page-section__content {
        color: var(--colour-dreamless-sleep);
        font-size: 1.6rem;
        line-height: 1.4;
        max-width: none;
        padding: 0;

        @include builder-mixins.rich-text-links;

        :global(p:not(:last-child)) {
            margin-bottom: 1.6rem;
        }
    }
</style>
